/**
 * Formats a Date object into a date  value for machine use.
 *
 * @param {Date} date
 * @return {String|null}
 */
const machineDateFormatter = (date) => {
  if (date instanceof Date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

  return null
}

export default machineDateFormatter
